import React, { Component } from "react";
import PropTypes from "prop-types";

import { Image, ImageContainer } from "./components";

const GRID_ROW_HEIGHT = 4; // Keep in sync with GalleryGrid grid-auto-rows
const GRID_GAP = 8; // Keep in sync with GalleryGrid gap

class GalleryImage extends Component {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();
    this.state = {
      span: 20,
      aspectRatio: null,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateSpan);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateSpan);
  }

  handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    if (!naturalWidth || !naturalHeight) {
      return;
    }

    const aspectRatio = naturalHeight / naturalWidth;

    this.setState({ aspectRatio }, this.updateSpan);
  };

  handleImageError = () => {
    this.setState({ aspectRatio: 1 }, this.updateSpan);
  };

  updateSpan = () => {
    const { aspectRatio } = this.state;
    const container = this.containerRef.current;

    if (!container || !aspectRatio) {
      return;
    }

    const columnWidth = container.clientWidth;
    if (!columnWidth) {
      return;
    }

    const imageHeight = aspectRatio * columnWidth;
    // Calculate span: each row is GRID_ROW_HEIGHT + gap between rows
    // Total height = (span * GRID_ROW_HEIGHT) + ((span - 1) * GRID_GAP)
    // Solving: span = (imageHeight + GRID_GAP) / (GRID_ROW_HEIGHT + GRID_GAP)
    const newSpan = Math.max(
      1,
      Math.round((imageHeight + GRID_GAP) / (GRID_ROW_HEIGHT + GRID_GAP))
    );

    this.setState((prevState) =>
      prevState.span === newSpan ? null : { span: newSpan }
    );
  };

  render() {
    const { alt, fullSizeUrl, src } = this.props;
    const { span } = this.state;

    return (
      <ImageContainer
        ref={this.containerRef}
        style={{ gridRowEnd: `span ${span}` }}
      >
        <a href={fullSizeUrl}>
          <Image
            src={src}
            alt={alt}
            onLoadComplete={this.handleImageLoad}
            onError={this.handleImageError}
          />
        </a>
      </ImageContainer>
    );
  }
}

GalleryImage.propTypes = {
  alt: PropTypes.string,
  fullSizeUrl: PropTypes.string,
  src: PropTypes.string.isRequired,
};
GalleryImage.defaultProps = {
  alt: "",
  fullSizeUrl: undefined,
};

export default GalleryImage;
